import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import Upload from '../../../../components/Input/Upload';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import LayoutContext from '../../../../store/Layout/contexts';
import { newFetch, GET, POST } from '../../../../helpers/fetch';
import AppContext from '../../../../store/App/contexts';

const AddCatalogue = ({ history }) => {
  const type = localStorage.getItem('type');
  const { fetchClientsOptions, client_options, selectedClientID } =
    React.useContext(AppContext);
  const [statusOptions, setStatusOptions] = useState([]);
  const [status, setStatus] = useState(0);
  const [client, setClient] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [howToSetup, setHowToSetup] = useState('');
  const [stock, setStock] = useState('');
  const [uploads, setUploads] = useState([]);

  const fetchStatusOptions = async () => {
    let api_path = `/fields/catalogue_status`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatusOptions(response.data);
    }
  };

  useEffect(() => {
    fetchStatusOptions();
    fetchClientsOptions(type);
  }, []);

  useEffect(() => {
    setClient(selectedClientID);
  }, [selectedClientID]);

  const handleDiscard = async () => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to discard all changes?'
    );
    if (isConfirmed) {
      setStatus(0);
      setName('');
      setDescription('');
      setHowToSetup('');
      setUploads([]);
    }
  };

  const validateForm = () => {
    if (parseInt(client) === 0 || !client) {
      ToastUtil.error('Please select a Client!');
      return false;
    }

    if (status === 0) {
      ToastUtil.error('Please select a Status!');
      return false;
    }

    if (!name) {
      ToastUtil.error('Please input Name!');
      return false;
    }

    if (uploads.length <= 0) {
      ToastUtil.error('Please insert Images to Upload!');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        'Are you sure you want to add this Catalogue?'
      ))
    ) {
      let formData = new FormData();

      formData.append('status', status);
      formData.append('name', name);
      formData.append('stock', stock);
      formData.append('description', description);
      formData.append('how_to_setup', howToSetup);
      formData.append('client_id', client);

      for (let file of uploads) {
        formData.append('files[]', file);
      }

      let api_path = `/catalogue`;
      let response = await newFetch(POST, api_path, formData, 'multi');

      ToastUtil.success(response.message);

      if (response.success) {
        history.push('/catalogue');
      }
    }
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to="/catalogue"
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to Catalogue
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Add New Catalogue</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => handleSubmit(e)}>
              <div
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded adjust-shadow">
                  <div
                    className="flex-grow-1 bg-white col-md-7"
                    style={{ padding: '2.25rem' }}
                  >
                    <div
                      className="row pb-3 col-md-12"
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <strong>Client</strong>
                      <p
                        style={{
                          fontSize: 20,
                          color: '#595b5f',
                          fontWeight: 500,
                          paddingLeft: 8,
                        }}
                      >
                        {client_options &&
                          selectedClientID &&
                          client_options.find(
                            (clnt) => clnt.id === parseInt(selectedClientID)
                          )?.name}
                      </p>
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Status*</strong>
                      <select
                        name="status"
                        className="form-select mt-3 adjust-fs"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value={0}>Select Status</option>
                        {statusOptions &&
                          statusOptions.map((status, index) => (
                            <option
                              key={`${status.id}_${index}`}
                              value={status.id}
                            >
                              {status.label}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Name*</strong>
                      <input
                        type="text"
                        className="form-control mt-3 adjust-fs"
                        placeholder="Name"
                        value={name}
                        onChange={({ target: { value } }) => setName(value)}
                      />
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Stock</strong>
                      <input
                        type="number"
                        className="form-control mt-3 adjust-fs"
                        placeholder="Stock"
                        value={stock || 0}
                        onChange={({ target: { value } }) => setStock(value)}
                      />
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>Description</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        placeholder="Description"
                        value={description}
                        onChange={({ target: { value } }) =>
                          setDescription(value)
                        }
                      />
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>How to Setup</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        placeholder="How to Setup"
                        value={howToSetup}
                        onChange={({ target: { value } }) =>
                          setHowToSetup(value)
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="flex-grow-1 bg-white col-md-5"
                    style={{ paddingTop: '2.25rem' }}
                  >
                    <div className="row pb-3 col-md-12">
                      <div className="col-12">
                        <strong>Images</strong>
                      </div>
                      <div className="pt-3 col-12">
                        <Upload
                          files={uploads}
                          setFiles={setUploads}
                          multiple={true}
                          accept={'image/*'}
                          sort={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-end"
              >
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={handleDiscard}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddCatalogue);
